import React from "react";
import {
  Box,
  Typography,
  Button,
  AppBar,
  Toolbar,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/logo-white.png";
import whatHappensNextIcon from "../assets/phoenwithmessage.png";
import { useAuthContext } from "../services/AuthContext";
import heroImage1 from "../assets/heroimage1.png";

function FinalSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout: authLogout } = useAuthContext();

  const selectedClaimDetails = location.state?.selectedClaimDetails || [];

  const handleLogout = () => {
    authLogout();
    navigate("/login");
  };

  if (!selectedClaimDetails.length) {
    navigate("/dashboard");
    return null;
  }

  return (
    <Box
      sx={{
        fontFamily: "'PP Neue Montreal', 'Inter', sans-serif",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        background: "#FFFFFF",
      }}
    >
      <AppBar
        position="sticky"
        sx={{
          background: `url(${heroImage1}) no-repeat center/cover`,
          boxShadow: "none",
          padding: "10px 117px",
          height: "260px",
          zIndex: 1,
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: "14px",
          }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{
              width: "118px",
              height: "67px",
              objectFit: "contain",
            }}
          />
          <Box
            sx={{
              display: "flex",
              gap: "20px",
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            <Button
              color="inherit"
              onClick={() => navigate("/dashboard")}
              sx={{
                color: "#FFFFFF",
                textTransform: "none",
                fontSize: "21px",
                fontWeight: 400,
                lineHeight: "200%",
                padding: "8px 16px",
                "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" },
              }}
            >
              Label Claims
            </Button>
            <Button
              color="inherit"
              onClick={() => navigate("/dashboard?view=orderDetails")}
              sx={{
                color: "#FFFFFF",
                textTransform: "none",
                fontSize: "21px",
                fontWeight: 400,
                lineHeight: "200%",
                padding: "8px 16px",
                "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" },
              }}
            >
              Order Details
            </Button>
            <Button
              color="inherit"
              onClick={() => navigate("/user-settings")}
              sx={{
                color: "#FFFFFF",
                textTransform: "none",
                fontSize: "21px",
                fontWeight: "400",
                lineHeight: "200%",
                padding: "8px 16px",
                "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" },
              }}
            >
              User Settings
            </Button>
          </Box>
          <Button
            color="inherit"
            onClick={handleLogout}
            sx={{
              color: "#FFFFFF",
              textTransform: "uppercase",
              fontSize: "16px",
              fontWeight: 700,
              fontFamily: "'Lato', sans-serif",
              lineHeight: "200%",
              padding: "8px 16px",
              "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" },
            }}
          >
            Logout
          </Button>
        </Toolbar>
        <Box
          sx={{
            height: "calc(260px - 64px)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "#FFFFFF",
            textAlign: "center",
            marginBottom: "50px",
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontWeight: 500,
              fontSize: "48px",
              lineHeight: "90%",
              fontFamily: "'PP Neue Montreal', 'Inter', sans-serif",
              textTransform: "none",
            }}
          >
            Book Label Claim {selectedClaimDetails[0]?.id || ""}
          </Typography>
        </Box>
      </AppBar>

      <Box sx={{ marginTop: "-70px", zIndex: 2, flex: 1, maxWidth:"100%", padding: { xs: "20px", md: "0px 117px" } }}>
        <Box
          sx={{
              backgroundColor: "#FFFFFF",
              borderRadius: "16px",
              border: "1px solid #ECECEC",
              boxShadow: "0px 14px 24px rgba(0, 0, 0, 0.05)",
              padding: "30px",
              width: "100%",
              height: "fit-content",
              position: "relative",
              
            }}
        >
          <Box sx={{
            backgroundColor: "#FFFFFF",
            borderRadius: "16px",
            border: "1px solid #F5D9B0",
            boxShadow: "none",
            padding: { xs: "20px", md: "40px" },
            maxWidth: { xs: "100%", md: "400px" },
            margin: "0 auto",
            textAlign: "center",
          }}
          >
            <Typography
              sx={{
                fontFamily: "'PP Neue Montreal', 'Inter', sans-serif",
                fontSize: "24px",
                fontWeight: 500,
                color: "#1E1E1E",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              Book Label Claim {selectedClaimDetails[0]?.id || ""}
            </Typography>
            <Box
              sx={{
                background: "#F5F5F5",
                borderRadius: "14px",
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                alignItems: "center",
              }}
            >
              {/* <img
                src={whatHappensNextIcon}
                alt="Payment Success Icon"
                style={{ width: "60px", height: "60px", marginBottom: "10px" }}
              /> */}
              <Typography
                sx={{
                  fontFamily: "'PP Neue Montreal', 'Inter', sans-serif",
                  fontSize: "24px",
                  fontWeight: 500,
                  color: "#1E1E1E",
                }}
              >
                Congratulations
              </Typography>
              <Typography
                sx={{
                  fontFamily: "'PP Neue Montreal', 'Inter', sans-serif",
                  fontSize: "18px",
                  fontWeight: 400,
                  color: "#1E1E1E",
                }}
              >
                Check Order Details at Dashbaord for Dossier file.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", gap: "20px", marginTop: "40px" }}>
              <Button
                onClick={() => navigate("/dashboard?view=orderDetails")}
                sx={{
                  backgroundColor: "#66202D",
                  color: "#FFFFFF",
                  borderRadius: "390px",
                  padding: "15px 30px",
                  fontFamily: "'PP Neue Montreal', 'Inter', sans-serif",
                  fontSize: "16px",
                  fontWeight: 500,
                  textTransform: "uppercase",
                  "&:hover": {
                    backgroundColor: "#551A25",
                  },
                }}
              >
                View Order Details
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          padding: "20px 136px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: "auto",
        }}
      >
        <Typography
          sx={{
            fontFamily: "'Lato', sans-serif",
            fontSize: "18px",
            fontWeight: 400,
            color: "#1E1E1E",
          }}
        >
          © 2025 DealSphere. All rights reserved.
        </Typography>
        <Box>
          <Button
            sx={{
              color: "#1E1E1E",
              fontFamily: "'Lato', sans-serif",
              fontSize: "18px",
              fontWeight: 400,
              textTransform: "none",
              mr: 2,
            }}
          >
            Terms
          </Button>
          <Button
            sx={{
              color: "#1E1E1E",
              fontFamily: "'Lato', sans-serif",
              fontSize: "18px",
              fontWeight: 400,
              textTransform: "none",
              mr: 2,
            }}
          >
            Privacy
          </Button>
          <Button
            sx={{
              color: "#1E1E1E",
              fontFamily: "'Lato', sans-serif",
              fontSize: "18px",
              fontWeight: 400,
              textTransform: "none",
            }}
          >
            Contact
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default FinalSuccess;